import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import axios from "axios";

import "swiper/css";
import "swiper/css/pagination";

export default function SliderSection() {
  const [dataSlider, setDataSlider] = useState([]);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://laravel-api.aj-mart.com/api/banners"
        );

        const banners = response?.data?.banners;

        if (!Array.isArray(banners)) {
          return;
        }

        const filteredData = banners.filter(
          (slide) => slide?.banner_offer_image
        );

        if (mounted) {
          setDataSlider(filteredData);
        }
      } catch (error) {
        console.error("Error When Fetch Banners:", error);
      }
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  if (dataSlider.length === 0) {
    return null;
  }

  return (
    <section className="relative py-12 bg-gray-50">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="relative rounded-xl overflow-hidden shadow-2xl">
          <Swiper
            modules={[Autoplay, Pagination]}
            slidesPerView={1}
            spaceBetween={0}
            speed={600}
            loop={false}
            autoplay={
              dataSlider.length > 1
                ? {
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }
                : false
            }
            pagination={
              dataSlider.length > 1
                ? {
                    clickable: true,
                    dynamicBullets: true,
                  }
                : false
            }
            className="w-full h-[300px]"
          >
            {dataSlider.map((slide, index) => (
              <SwiperSlide key={slide.id}>
                <div className="relative w-full h-full">
                  <img
                    src={`https://laravel-api.aj-mart.com/storage/app/public/${slide.banner_offer_image}`}
                    alt=""
                    loading={index === 0 ? "eager" : "lazy"}
                    decoding="async"
                    className="w-full h-full object-cover"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}